import React from "react";
import Heading from "../sub-component/heading/heading.sub-component";

const Footer = () => {
  const whatsappMessage = "Hii Tara I want to connect";
  return (
    <div
      className="w-full bg-primaryBg px-4 md:px-6 lg:pl-28 lg:px-8 py-8 md:py-12 lg:py-16"
      // data-aos="fade-down"
      // data-aos-duration={1000}
      // data-aos-delay={400}
    >
      <div className="w-full flex flex-col md:flex-row gap-4 md:gap-6 lg:gap-8">
        <div className="w-full flex  lg:w-1/3">
          <div className="flex flex-col gap-4">
            <div>
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNAjS0YiR_2QHIwXr14ElMssHIMd7QhU3YZX1qNODdDA&s"
                alt="Screenshot-2024-03-01-at-9-42-57-PM"
                className="h-8 lg:h-10 rounded-full"
              />
            </div>
            <Heading className="text-gray-600">
              We work with leaders with extraordinary capabilities and
              leadership to create value and profitable businesses, often from
              ground up. We are the software engineering team behind products
              that touches millions of lives and generates millions in profits.
            </Heading>
          </div>
        </div>
        <div className="w-full flex lg:w-1/3 md:justify-center">
          <div className="flex flex-col gap-4">
            <h1 className="text-xl">Company</h1>
            <div className="flex flex-col gap-2">
              <Heading>
                <a href="#about">About Us</a>
              </Heading>
              <Heading>
                <a href="#team">Our Team</a>
              </Heading>
              <Heading>
                <a href="#contact">Contact Us</a>
              </Heading>
              <Heading>
                <a href="mailto:tarachand122333@gmail.com" target=" _blank" className="hover:underline">
                  tarachand122333@gmail.com
                </a>
              </Heading>
            </div>
          </div>
        </div>
        <div className="w-full flex  lg:w-1/3">
          <div className="flex flex-col gap-4">
            <h1 className="text-xl">Connect With Us</h1>
            <div className="flex gap-4">
              {/* <div className="">
                <img
                  src="https://freelogopng.com/images/all_img/1658586823instagram-logo-transparent.png"
                  alt="instagram"
                  className="w-10 md:w-12 md:h-12 h-10 cursor-pointer"
                />
              </div> */}
              {/* <a
                href={`https://wa.me/+917229804925/?text=${whatsappMessage}`}
                target=" _blank"
              >
                <img
                  src="https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/whatsapp-business-icon.png"
                  alt="whats-app"
                  className="h-10 md:w-12 md:h-12 w-10 cursor-pointer"
                />
              </a> */}
              <a href="mailto:tarachand122333@gmail.com" target=" _blank">
                <img
                  src="https://static.vecteezy.com/system/resources/previews/010/153/613/non_2x/email-and-mail-icon-sign-symbol-design-free-png.png"
                  alt="email"
                  className="h-10 md:w-12 md:h-12 w-10 cursor-pointer"
                />
              </a>
              <a
                href={`https://www.linkedin.com/company/yourtechcompany`}
                target=" _blank"
              >
                <img
                  src="https://i.ibb.co/BcVVwBv/Linked-In-logo-initials.png"
                  alt="whats-app"
                  className="h-10 md:w-12 md:h-12 w-10 cursor-pointer"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center items-center border-t py-2 my-4">
        <h3>&#169; 2024 Your Tech Company | All rights reserved</h3>
      </div>
    </div>
  );
};

export default Footer;
